var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.334.285a.454.454 0 0 0-.857.3c.698 2.005-.687 3.502-1.743 4.304l-.426-.611a.996.996 0 0 0-.714-.379L8.2 3.91a1.624 1.624 0 0 0-.824.255L.322 9.11a.758.758 0 0 0-.186 1.055l3.206 4.587c.24.341.624.3.967.061l7.054-4.947c.203-.144.437-.453.52-.69l.75-2.361a.997.997 0 0 0-.112-.8l-.26-.373c1.418-1.087 2.89-3.007 2.073-5.357Zm-3.282 7.027a1.207 1.207 0 0 1-1.682-.297 1.212 1.212 0 0 1 1-1.905c.251.002.496.083.699.231a4.63 4.63 0 0 1-.371.207.455.455 0 0 0 .387.821c.146-.069.302-.15.465-.248a1.213 1.213 0 0 1-.498 1.191Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.53ace45fd2d34a565303c992b2bdb239.svg";
export { ForwardRef as ReactComponent };